import { GroupedListData } from 'modules/analytics/common/types';
import { sumScoreField } from 'modules/analytics/common/utils';
import { npsScore } from 'modules/analytics/survey/utils/survey-scores';
import SurveyRateCell from 'modules/survey/management/components/SurveyRateCell/SurveyRateCell';

const NpsSatScoreCell = ({ data }: { data: GroupedListData }) => {
  const promotersTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'positivesTotal') : data.positivesTotal;
  const detractorsTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'negativesTotal') : data.negativesTotal;
  const totalReactions = data.isGroup ? sumScoreField(data?.scoreData || [], 'totalReactions') : data.totalReactions;
  const unAnsweredTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'unansweredTotal') : data.unansweredTotal;

  return (
    <SurveyRateCell
      key={data._id}
      number={npsScore(promotersTotal || 0, detractorsTotal || 0, (totalReactions || 0) + (unAnsweredTotal || 0))}
    />
  );
};

export default NpsSatScoreCell;
